export const defaultAriaConfig = {
  collectorUriForTelemetry: "",
  ariaTelemetryKey: "c7655518acf1403f93ff6b9f77942f0a-d01a02fd-6b50-4de3-a566-62eda11f93bc-7083",
  ariaTelemetryApplicationName: "D365_Omnichannel_Client_Public_Prod",
  disableCookieUsage: true
};